import React from 'react';
import PropTypes from 'prop-types';

import {
  CloseButton,
  Container,
  ImagePreview,
  Icon,
} from './styles';

const RemovableImage = (props) => {
  const {
    src,
    alt,
    onRemove,
    maxHeight,
    canRemoveImage,
  } = props;

  return (
    <Container>
      <ImagePreview
        src={src}
        alt={alt}
        maxHeight={maxHeight}
      />
      {
        canRemoveImage
        && (
          <CloseButton
            onClick={onRemove}
          >
            <Icon name="x" />
          </CloseButton>
        )
      }
    </Container>
  );
};

RemovableImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  maxHeight: PropTypes.string,
  canRemoveImage: PropTypes.bool,
};

RemovableImage.defaultProps = {
  maxHeight: undefined,
  canRemoveImage: true,
};

export default RemovableImage;
